/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';

import { syncProductHasVariants } from './helpers/productVariantsHelpers';

export const getVariantsBulk = createAsyncThunk(
  'products/getVariantsBulk',
  async ({ productIds }, {
    extra: {
      sdk, Logger, showErrorDialog, utils,
    },
  }) => {
    try {
      const uniqueIds = [...new Set(productIds)];
      if (!uniqueIds.length) return {};

      const { data } = await sdk.products.listMasterVariants(uniqueIds);
      return data?.variantsByProductId || {};
    } catch (error) {
      const errorMessage = utils.getDataFromResponceError(error, 'msg') || 'Can not get product variants';
      showErrorDialog(errorMessage);
      Logger.error(new Error('Error getting product variants in bulk'), { error }, [
        'GetProductVariantsBulkFailed',
        { errorMessage: errorMessage || 'NoMessage' },
      ]);
      throw error;
    }
  },
);

const applyVariantsToProduct = (product, variants) => {
  product.variants = variants || [];
  syncProductHasVariants(product);
  delete product.isBusy;
};

export const reducer = (builder) => {
  builder
    .addCase(
      getVariantsBulk.pending,
      (state, { meta }) => {
        const { productIds } = meta.arg;
        state.items.forEach((product) => {
          if (productIds.includes(product._id)) product.isBusy = true;
        });
      },
    )
    .addCase(
      getVariantsBulk.fulfilled,
      (state, { payload, meta }) => {
        const { productIds } = meta.arg;

        state.items.forEach((product) => {
          if (!productIds.includes(product._id)) return;

          const variants = payload?.[product._id] ?? payload?.[String(product._id)] ?? [];
          applyVariantsToProduct(product, variants);
        });
      },
    )
    .addCase(
      getVariantsBulk.rejected,
      (state, { meta, error }) => {
        state.items.forEach((item) => {
          if (meta.arg.productIds.includes(item._id)) {
            delete item.isBusy;
          }
        });
        state.error = error;
      },
    );
};
